import { getEnvironmentName } from "../../environment";

// Any subdomain of
//  https://*.justworks.com
//  https://*.justworkshours.com
//  https://*.justworkslabs.com
// either ends on .justworks.com or  allows justworks.com/example/path or justworks.com?example=param
// does not permit .justworks.com.attacker.com
const ALLOWED_ORIGIN_JUSTWORKS_REGEX =
  /^https:\/\/(?:[\w\-_]+\.)+justworks(?:labs|hours)?\.com(?:\/|$|\?)/;
const LOCALHOST_REGEX = /^https?:\/\/localhost:[0-9]{1,5}(?:\/|$|\?)/;

const getReferrerRegex = (): RegExp => {
  if (getEnvironmentName() === "production") {
    return ALLOWED_ORIGIN_JUSTWORKS_REGEX;
  } else {
    return new RegExp(
      `${ALLOWED_ORIGIN_JUSTWORKS_REGEX.source}|${LOCALHOST_REGEX.source}`,
    );
  }
};

const isValidReferrer = (referrer: string): boolean => {
  let decodedUrl;

  try {
    decodedUrl = decodeURIComponent(referrer);
  } catch {
    console.error("Invalid referrer query param URL passed: ", referrer);
    return false;
  }

  const referrerRegex = getReferrerRegex();

  return referrerRegex.test(decodedUrl);
};

export default isValidReferrer;
